"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRemainderToSplit = exports.splitTxnRemainder = exports.sumSplitRows = void 0;
const immutable_1 = require("immutable");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
function sumSplitRows(items) {
    let sum = 0;
    items.forEach((splitItem) => {
        sum += Number(splitItem.amount);
    });
    return Number(sum.toFixed(2));
}
exports.sumSplitRows = sumSplitRows;
const splitTxnRemainder = (txn) => { var _a; return ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items) && Number((Number(txn.amount) - sumSplitRows(txn.split.items)).toFixed(2)); };
exports.splitTxnRemainder = splitTxnRemainder;
function addRemainderToSplit(txn, remainder) {
    const itemIndex = txn.split.items.findIndex((item) => ((item.coa && item.coa.type === 'UNCATEGORIZED') && Number(item.coa.id) === 0));
    if (itemIndex !== -1) {
        // getting some bugsnag errors QWA-7095 where items.get is not a function, using assert to find case in QA
        assert(txn.split.items.get, 'Split Items not immutable: SP-105/TV - Please tell Tim what you just did');
        if ((0, immutable_1.isImmutable)(txn.split.items)) {
            let item = txn.split.items.get(itemIndex);
            item = item.set('amount', Number(item.amount) + remainder);
            const newItems = txn.split.items.set(itemIndex, item);
            return txn.setIn(['split', 'items'], newItems);
        }
    }
    // need to create the uncategorized row
    const newItem = transactions_1.transactionsTypes.mkSplitItem({
        amount: remainder,
        coa: chart_of_accounts_1.chartOfAccountsTypes.mkChartOfAccount({ id: '0', type: 'UNCATEGORIZED' }),
    });
    const newTxn = txn.setIn(['split', 'items'], txn.split.items.push(newItem));
    return newTxn;
}
exports.addRemainderToSplit = addRemainderToSplit;
